import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import getLocaleMessages from '../../../utils/localesMessages';
import { TextInput } from '@paypalcorp/pp-react';
import { getUserType } from '../../../utils/buttonFactoryUtils';

const {
  orgName: { label: orgLabel },
  displayName: { label: displayNameLabel },
} = getLocaleMessages('buttonsV3/receiver');
const isBusinessAccount = getUserType() === 'BUSINESS';

const renderOrgNameTextField = (props) => {
  return <TextInput value={props.input.value} {...props} />;
};

function OrganizationName() {
  return (
    <Field
      id="orgName"
      name="receiverName"
      label={isBusinessAccount ? orgLabel : displayNameLabel}
      component={renderOrgNameTextField}
      readOnly={true}
      className="organization-name"
    />
  );
}

renderOrgNameTextField.propTypes = {
  input: PropTypes.object,
};

export default OrganizationName;
